// ============================================================
// PAYMENT PLANS KPIs COMPONENT
// ============================================================

import { formatAmount } from '@common/utils';
import { AlertCircle, CheckCircle2, Clock, CreditCard, DollarSign } from 'lucide-react';
import { KPIWidget } from '../common/KPIWidget';

interface PaymentPlansKPIsProps {
  stats: {
    total: number;
    active: number;
    overdue: number;
    completed: number;
    totalAmount: number;
  };
}

export function PaymentPlansKPIs({ stats }: PaymentPlansKPIsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      <KPIWidget
        title="Total Plans"
        value={stats.total.toString()}
        subtext="Tous statuts"
        trend="up"
        color="primary"
        icon={<CreditCard className="w-5 h-5" />}
      />
      <KPIWidget
        title="En Cours"
        value={stats.active.toString()}
        subtext="Paiements actifs"
        trend="up"
        color="secondary"
        icon={<Clock className="w-5 h-5" />}
      />
      <KPIWidget
        title="En Retard"
        value={stats.overdue.toString()}
        subtext="Action requise"
        trend={stats.overdue > 0 ? 'down' : 'up'}
        color="magenta"
        icon={<AlertCircle className="w-5 h-5" />}
      />
      <KPIWidget
        title="Terminés"
        value={stats.completed.toString()}
        subtext="Paiements complets"
        trend="up"
        color="success"
        icon={<CheckCircle2 className="w-5 h-5" />}
      />
      <KPIWidget
        title="Montant Total"
        value={formatAmount(stats.totalAmount)}
        subtext="Tous plans confondus"
        trend="up"
        color="primary"
        icon={<DollarSign className="w-5 h-5" />}
      />
    </div>
  );
}
